import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IControlValidatorFieldValidatorFn } from '../models/control-validator.model';
import { IOfficeField } from '@pages/office/models/office-data.model';

export const NUMBER_RANGE: Record<string, { min: bigint; max: bigint }> = {
  byte: { min: 0n, max: 255n },
  short: { min: -32768n, max: 32767n },
  int: { min: -2147483648n, max: 2147483647n },
  long: { min: -9223372036854775808n, max: 9223372036854775807n },
};

export class NumericRangeValidator extends IControlValidatorFieldValidatorFn {
  static override errorKey = 'numericRange';

  static errorMessage(min: bigint, max: bigint): string {
    return `Value is out of range. Must be an integer between ${min} and ${max}.`;
  }

  static validate({ field }: { field: IOfficeField }): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value || !Object.keys(NUMBER_RANGE).includes(field.WebInputType)) {
        return null;
      }
      let value: bigint;
      try {
        value = BigInt(control.value);
      } catch {
        return null;
      }

      const min: bigint = NUMBER_RANGE[field.WebInputType].min;
      const max: bigint = NUMBER_RANGE[field.WebInputType].max;
      const isValid: boolean = value >= min && value <= max;

      return isValid ? null : this.validationErrors(this.errorKey, this.errorMessage(min, max));
    };
  }
}
